import { Button, Flex } from "antd"
import { Text, Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import { Avatar } from "ui/Avatar"
import styles from "./index.module.css"
import ClientContact from "pagesV2/pro/clients/ClientContact"
import { formatPhoneNumber } from "utils/data-formatters"
import { Icon } from "ui/Icon"
import PropTypes from "prop-types"
import { useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { routes } from "router"

const ClientDetails = ({ client, bookingUuid, bookingId }) => {
  const { name, first_name, last_name, phone, email, profileImageUrl, id } = client || {}
  const { t } = useTranslation()
  const navigate = useNavigate()

  const clientDataForContact = useMemo(() => {
    return {
      ...client,
      user: {
        first_name,
        last_name,
        phone_number: phone,
        email
      }
    }
  }, [client, first_name, last_name])

  return (
    <Flex vertical gap={20} className={`${styles.clientDetailsContainer} p-xl`}>
      <Flex justify="space-between" align="center">
        <Title level={4}>{t("client.client_details")}</Title>
        {Object.keys(client).length > 0 && <ClientContact client={clientDataForContact} bookingUuid={bookingUuid} bookingId={bookingId} />}
      </Flex>
      <Flex align="center" gap={16}>
        {name && <Avatar fullName={name} src={profileImageUrl} size={80} />}
        <Flex vertical gap={8}>
          <Title level={5} className={styles.clientNameLink} onClick={() => id && navigate(routes.guideClientPath({ id: id }))}>
            {name}
          </Title>
          <Flex className={styles.contactDetails}>
            {phone && (
              <Button className="justify-start pl-0" variant="link" color="primary" onClick={() => window.open(`tel:${phone}`)}>
                <Icon type="feather" name="Phone" width={16} height={16} />
                <Text>{formatPhoneNumber(phone)}</Text>
              </Button>
            )}
            {email && (
              <Button className="justify-start pl-0" variant="link" color="primary" onClick={() => window.open(`mailto:${email}`)}>
                <Icon type="feather" name="Mail" width={16} height={16} />
                <Text style={{ whiteSpace: "pre-wrap" }}> {email}</Text>
              </Button>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

ClientDetails.propTypes = {
  client: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    profileImageUrl: PropTypes.string,
    user_id: PropTypes.string,
    email_templates_collection: PropTypes.array,
    text_templates_collection: PropTypes.array
  }),
  bookingUuid: PropTypes.string,
  bookingId: PropTypes.number
}

ClientDetails.defaultProps = {
  client: {}
}

export default ClientDetails
